// Function to check if the device is mobile
function isMobile() {
  return window.innerWidth <= 768;
}

// Check if we're in a browser environment
if (typeof window !== 'undefined') {
  if (!isMobile()) {
    document.querySelectorAll('div.grid-overflow-wrapper').forEach(container => {
      container.addEventListener('scroll', event => {
        checkVisibility(container);
      });
    });

    document.querySelectorAll('button.carat-previous').forEach(button => {
      button.addEventListener('click', event => {
        let container = button.closest('div').querySelector('div.grid-overflow-wrapper');
        let scrollAmount = button.closest('div').querySelector('div.grid__item').getBoundingClientRect().width;
        container.scrollLeft -= scrollAmount;
        checkVisibility(container);
      });
    });

    document.querySelectorAll('button.carat-next').forEach(button => {
      button.addEventListener('click', event => {
        let container = button.closest('div').querySelector('div.grid-overflow-wrapper');
        let scrollAmount = button.closest('div').querySelector('div.grid__item').getBoundingClientRect().width;
        container.scrollLeft += scrollAmount;
        checkVisibility(container);
      });
    });
  }
}

function checkVisibility(container) {
  let seeMoreLink = container.closest('div').querySelector('div.see-more a');
  let nextButton = container.parentElement.querySelector('button.carat-next');
  let prevButton = container.parentElement.querySelector('button.carat-previous');
  if (seeMoreLink) {
    let linkRect = seeMoreLink.getBoundingClientRect();
    let containerRect = container.getBoundingClientRect();

    if (linkRect.left >= containerRect.left && linkRect.right <= containerRect.right) {
      nextButton.style.display = 'none';
    } else {
      nextButton.style.display = 'block';
    }
    if (container.scrollLeft === 0) {
      prevButton.style.opacity = '0';
    } else {
      prevButton.style.opacity = '1';
    }
  }
}

// Klaviyo helpers
function setupKlaviyoFormHandler(formId) {
  const observer = new MutationObserver((mutations, obs) => {
    const klaviyoForm = document.querySelector(`[data-testid="klaviyo-form-${formId}"]`);
    if (klaviyoForm) {
      const closeButton = klaviyoForm.previousElementSibling;
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          const event = new CustomEvent('klaviyoFormClosed', {
            bubbles: true,
            detail: { formId: formId }
          });
          document.dispatchEvent(event);
        });
      }
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (isMobile()) {
  setupKlaviyoFormHandler('Sh3ka3');
} else {
  setupKlaviyoFormHandler('WMZr53');
}

document.addEventListener('klaviyoFormClosed', (event) => {
  if(event.detail.formId === 'Sh3ka3') {
    if(isMobile()) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'RHZuU6']);
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'RcZem8']);
    }
  } else if(event.detail.formId === 'WMZr53') {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RcZem8']);
  }
});

// Region-specific popups
document.addEventListener("DOMContentLoaded", () => {
  const targetRegion = window.theme?.settings?.popupRegion;
  const cutoffDateStr = window.theme?.settings?.popupEnd;
  const formIdMobile = window.theme?.settings?.popupMobile;
  const formIdDesktop = window.theme?.settings?.popupDesktop;
  const KLAVIYO_POPUP_KEY = `klaviyo_popup_shown_${targetRegion || 'default'}`;

  function shouldShowPopup() {
    if (!window.Shopify?.customerPrivacy) return false;
    const region = window.Shopify.customerPrivacy.getRegion();
    if (!region || !targetRegion || region !== targetRegion) return false;
    if (!cutoffDateStr) return false;
    const [datePart, timePart] = cutoffDateStr.split(' ');
    if (!datePart) return false;
    const [mm, dd, yyyy] = datePart.split('-');
    const [hh = '00', min = '00'] = (timePart || '').split(':');
    const cutoffDate = new Date(`${yyyy}-${mm}-${dd}T${hh}:${min}:00`);
    if (isNaN(cutoffDate.getTime())) return false;
    const now = new Date();
    if (now >= cutoffDate) return false;
    return true;
  }

  function checkRegionAndRunPopups() {
    if (!shouldShowPopup()) return;
    const hasSeenKlaviyoPopup = localStorage.getItem(KLAVIYO_POPUP_KEY);
    if (hasSeenKlaviyoPopup === 'closed') return;
    const currencyModal = document.getElementById('currency-modal');
    const isCurrencyModalOpen = currencyModal && currencyModal.hasAttribute('open');
    if (isCurrencyModalOpen) {
      setTimeout(checkRegionAndRunPopups, 1000);
      return;
    }
    setTimeout(() => {
      const klaviyoScript = document.querySelector('script[src*="klaviyo.js"]');
      const formId = isMobile() ? formIdMobile : formIdDesktop;
      if (!formId) return;

      function showKlaviyoForm() {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
        setTimeout(() => {
          const form = document.querySelector(`[data-testid="klaviyo-form-${formId}"]`);
          if (form) {
            const closeButton = form.previousElementSibling;
            if (closeButton) {
              closeButton.addEventListener('click', () => {
                localStorage.setItem(KLAVIYO_POPUP_KEY, 'closed');
              });
            }
          }
        }, 1000);
        localStorage.setItem(KLAVIYO_POPUP_KEY, 'shown');
      }
      if (!klaviyoScript) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js';
        script.onload = showKlaviyoForm;
        document.head.appendChild(script);
      } else {
        showKlaviyoForm();
      }
    }, 5000);
  }

  function initPrivacyChecks() {
    if (window.Shopify?.customerPrivacy) {
      const consentFromCustomer = window.Shopify.customerPrivacy.currentVisitorConsent();
      if (consentFromCustomer) {
        checkRegionAndRunPopups();
      } else {
        document.addEventListener("visitorConsentCollected", () => {
          checkRegionAndRunPopups();
        });
      }
    } else {
      setTimeout(initPrivacyChecks, 100);
    }
  }

  initPrivacyChecks();

  addDismissToCookieBanner();
});

// Utility: Wait for an element to appear in the DOM
function waitForElement(selector, timeout = 10000) {
  return new Promise((resolve, reject) => {
    const el = document.querySelector(selector);
    if (el) return resolve(el);
    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        resolve(el);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => {
      observer.disconnect();
      reject(new Error('Element not found: ' + selector));
    }, timeout);
  });
}

// Add a dismiss button to the Shopify cookie banner that only allows necessary cookies
function addDismissToCookieBanner() {
  waitForElement('#shopify-pc__banner').then(banner => {
    if (banner.querySelector('.custom-dismiss-btn')) return;

    const dismissBtn = document.createElement('button');
    dismissBtn.innerHTML = '&times;';
    dismissBtn.className = 'custom-dismiss-btn';
    dismissBtn.setAttribute('aria-label', 'Dismiss and accept necessary cookies only');
    dismissBtn.style = `
      position: absolute;
      top: 8px;
      right: 8px;
      background: transparent;
      border: none;
      font-size: 1.5rem;
      color: #333;
      cursor: pointer;
      padding: 0;
      margin: 0;
      z-index: 10;
    `;

    dismissBtn.addEventListener('click', () => {
      const necessaryBtn = banner.querySelector('#shopify-pc__banner__btn-decline');
      if (necessaryBtn) {
        necessaryBtn.click();
      }
    });

    if (getComputedStyle(banner).position === 'static') {
      banner.style.position = 'relative';
    }

    banner.appendChild(dismissBtn);
  }).catch(() => {
  });
}